import { usStates } from "./us-states";
import { caStates } from "./ca-states";

export function getAvailableCountryStates(countryIsoCode: string) {
  switch (countryIsoCode.toUpperCase()) {
    case "US": {
      return usStates;
    }
    case "CA": {
      return caStates;
    }
    default: {
      return undefined;
    }
  }
}
